export enum Type {
  VIDEO_CLIP_WIZARD_TRACE_ID_SET = 'app/video-clip-wizard/VIDEO_CLIP_WIZARD_TRACE_ID_SET',

  VIDEO_CLIP_WIZARD_DATA_LOAD_REQUEST = 'app/video-clip-wizard/VIDEO_CLIP_WIZARD_DATA_LOAD_REQUEST',
  VIDEO_CLIP_WIZARD_DATA_LOAD_SUCCESS = 'app/video-clip-wizard/VIDEO_CLIP_WIZARD_DATA_LOAD_SUCCESS',
  VIDEO_CLIP_WIZARD_DATA_LOAD_FAILURE = 'app/video-clip-wizard/VIDEO_CLIP_WIZARD_DATA_LOAD_FAILURE',
}
